export const ALL_TIMES_RECEIVED = 'all-times-received';
export const ERROR = 'error';
export const LOAD_TIMES = 'load-times';
export const RESET = 'reset';
